// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"25":"chunk-artplayer","62":"video-player","677":"search-page","941":"video-grid","998":"home-page"}[chunkId] + "." + {"25":"b81f1e7b","62":"96e8b851","677":"04f792cc","941":"ec682b89","998":"4bf64bf7"}[chunkId] + ".js";
};